import { createContext } from 'react';

export interface ModalDialogContextProps {
  data: Record<string, unknown>;
}

export const ModalDialogContext = createContext<ModalDialogContextProps>(undefined!);
